module.exports = __webpack_public_path__ + "static/media/1.e888c9e8.svg";